import { FacebookLogo } from '@/assets/svg';
import BaseSocialModal from './BaseSocialModal';

export default class Facebook extends BaseSocialModal {
  constructor(props) {
    super(props, 'Facebook');
    this.logo = FacebookLogo;
  }

  render() {
    return this.renderSocialModal();
  }
}
